import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {Partner} from "../../../../shared/interface/partner";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";
import {ReceivablesBalance} from "../../../../shared/interface/receivables-balance";
import {a} from "@fullcalendar/core/internal-common";
import {LogService} from "../../../../shared/services/log.service";
import {takeUntil} from "rxjs/operators";
import {Log} from "../../../../shared/interface/log";


@Component({
  selector: 'app-receivables-balance-details-view',
  templateUrl: './receivables-balance-details-view.component.html',
  styleUrls: ['./receivables-balance-details-view.component.scss']
})
export class ReceivablesBalanceDetailsViewComponent implements  OnInit, OnDestroy {
  @Input() receivablesBalanceObject: ReceivablesBalance;
  @Input() receivablesBalanceId?: string = null;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() ofwcaChanged = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;
  initialFilters: any;
  receivablesBalance?:  ReceivablesBalance;
  logs: any[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private receivablesBalanceService: ReceivablesBalanceService,
    private logService: LogService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    // this.loadListData();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.receivablesBalanceService.get(this.receivablesBalanceId).subscribe((receivablesBalance: ReceivablesBalance) => {
      this.receivablesBalanceObject = receivablesBalance;
      const log: Log[] = [];
      this.logService.getReceivablesBalanceRemindeLogDate(receivablesBalance.uuid, 0, 3)
        .pipe(
          takeUntil(this.destroyed$)
        ).subscribe((result) => {
        log.push(result);
      });
      this.logs = log;
    });
  }

}
